import { PropsWithChildren } from 'react';
import * as SC from './styles';
import { IBoxProps } from './types';
const ButtonBase: React.FC<PropsWithChildren<IBoxProps>> = ({
  children,
  disabled,
  onClick,
  isNotHover,
  ...rest
}) => {
  return (
    <SC.Container
      onClick={onClick}
      disabled={disabled}
      isNotHover={isNotHover}
      style={{ ...rest }}
    >
      {children}
    </SC.Container>
  );
};

export default ButtonBase;
